import { render } from "./AddEditService.vue?vue&type=template&id=28289228&ts=true"
import script from "./AddEditService.ts?vue&type=script&lang=ts&external"
export * from "./AddEditService.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__